module.exports = __webpack_public_path__ + "img/foto1.c28e0c76.webp";